// import React, { useEffect, useRef, useState } from "react";
// import { calender } from "../../assets/img";

// const DateRange = ({ fromDate, toDate, setFromDate, setToDate }) => {
//   const [selectedDates, setSelectedDates] = useState({
//     from: "",
//     to: "",
//   });

//   useEffect(() => {
//     if (selectedDates?.from && selectedDates?.to) {
//       setFromDate(selectedDates.from);
//     }
//     if (selectedDates?.from && selectedDates?.to) {
//       setToDate(selectedDates.to);
//     }
//   }, [selectedDates.from, selectedDates.to]);

//   const fromDateRef = useRef(null);
//   const toDateRef = useRef(null);

//   const openFromDatePicker = () => {
//     try {
//       fromDateRef.current?.showPicker();
//     } catch {
//       fromDateRef.current?.click();
//     }
//   };
//   const openToDatePicker = () => {
//     try {
//       toDateRef.current.showPicker?.();
//     } catch {
//       toDateRef.current.click();
//     }
//   };

//   return (
//     <div className="d-flex ac-jb gap-2">
//       {/* From Date */}
//       <div
//         className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js bg-lt-primary"
//         onClick={openFromDatePicker}
//         style={{ cursor: "pointer" }}
//       >
//         <img src={calender} className="calender-icon me-2" alt="calendar" />
//         <div style={{ width: "115px" }}>
//           <p className="f2 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14 mb-0">
//             From Range:
//           </p>
//           <input
//             ref={fromDateRef}
//             type="date"
//             value={selectedDates.from}
//             onChange={(e) => setSelectedDates({ from: e.target.value, to: "" })}
//             className="border-0 w-100 no-calendar-icon f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14 bg-transparent"
//             placeholder="From Date"
//             style={{ pointerEvents: "none" }}
//           />
//         </div>
//       </div>

//       {/* To Date */}
//       <div
//         className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js bg-lt-primary"
//         onClick={openToDatePicker}
//         style={{ cursor: "pointer" }}
//       >
//         <img src={calender} className="calender-icon me-2" alt="calendar" />
//         <div style={{ width: "115px" }}>
//           <p className="f2 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14 mb-0">
//             To Range:
//           </p>
//           <input
//             ref={toDateRef}
//             type="date"
//             min={selectedDates.from || ""}
//             value={selectedDates.to}
//             onChange={(e) =>
//               setSelectedDates((prev) => ({ ...prev, to: e.target.value }))
//             }
//             className="border-0 w-100 no-calendar-icon f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14 bg-transparent"
//             placeholder="To Date"
//             style={{ pointerEvents: "none" }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DateRange;

import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateRange = ({ fromDate, setFromDate, toDate, setToDate }) => {
  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (toDate && date && toDate < date) {
      setToDate(null);
    }
  };
  return (
    <>
      <div className="col-md-2 date-range">
        {/* <label className="form-label">From Date</label> */}
        <DatePicker
          selected={fromDate}
          onChange={handleFromDateChange}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select From Date"
          isClearable
          className="form-control"
          onKeyDown={(e) => e.preventDefault()}
        />
      </div>

      {/* To Date */}
      <div className="col-md-2 date-range">
        {/* <label className="form-label">To Date</label> */}
        <DatePicker
          selected={toDate}
          onChange={(date) => setToDate(date)}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select To Date"
          minDate={fromDate} // prevent selecting before fromDate
          isClearable
          className="form-control"
          onKeyDown={(e) => e.preventDefault()}
        />
      </div>
    </>
  );
};

export default DateRange;
